import { Moon, Sun } from 'lucide-react'

const tokens = [
  { name: 'GColors', description: 'Base color palette' },
  { name: 'GSystemColors', description: 'System-level colors' },
  { name: 'GColorScheme', description: 'Semantic color mapping' },
  { name: 'GSpacing', description: 'Spacing scale' },
  { name: 'GTypography', description: 'Type styles' },
  { name: 'GBorderRadius', description: 'Corner radii' },
  { name: 'GShadows', description: 'Elevation shadows' },
  { name: 'GBreakpoints', description: 'Responsive breakpoints' },
  { name: 'GDurations', description: 'Animation durations' },
  { name: 'GEasing', description: 'Animation curves' },
  { name: 'GOpacity', description: 'Opacity values' },
]

export function TokensSection() {
  return (
    <section className="bg-gray-50 py-24 dark:bg-[#0A0A0B]">
      <div className="mx-auto max-w-[1152px] px-6">
        <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Left: Content */}
          <div>
            <h2 className="mb-4 font-sans text-3xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl">
              Design Tokens
            </h2>
            <p className="mb-2 text-lg text-gray-600 dark:text-white/70">
              Generated from JSON to Dart
            </p>
            <p className="mb-8 text-gray-500 dark:text-white/60">
              Tokens are generated from JSON into structured Dart APIs. Define
              once, use everywhere.
            </p>

            {/* Light/Dark Mode Badge */}
            <div className="inline-flex items-center gap-3 rounded-full border border-gray-200 bg-white px-4 py-2 dark:border-white/10 dark:bg-white/5">
              <Sun className="h-4 w-4 text-amber-500 dark:text-amber-400" />
              <span className="text-sm text-gray-600 dark:text-white/70">
                Supports Light & Dark mode
              </span>
              <Moon className="h-4 w-4 text-indigo-500 dark:text-indigo-400" />
            </div>
          </div>

          {/* Right: Token List */}
          <div className="rounded-2xl border border-gray-200 bg-white p-6 dark:border-white/10 dark:bg-[#111113]">
            <div className="grid gap-3">
              {tokens.map((token, i) => (
                <div
                  key={i}
                  className="flex items-center justify-between rounded-xl bg-gray-50 px-4 py-3 transition-colors hover:bg-gray-100 dark:bg-white/5 dark:hover:bg-white/[0.07]"
                >
                  <code className="font-mono text-sm font-medium text-[#448AFF]">
                    {token.name}
                  </code>
                  <span className="text-sm text-gray-500 dark:text-white/50">
                    {token.description}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
